import { countdownStep } from '../audio/countdown.js';
import { audio } from '../audio/engine.js';
import { prefs } from '../state/prefs.js';
import { el } from './dom.js';

/**
 * The countdown before a table's match: five, four, three, two, one, GO.
 *
 * The server deals when the host presses start but accepts no move until the
 * countdown ends, so everybody starts together. This is the part people see
 * and hear: a large number over everything, the letters hidden behind it
 * until GO, and each number sounded in the style this device chose.
 */

let until = 0;

/** True while a countdown is on screen: moves are not sent, the server would refuse them. */
export const countingDown = (): boolean => performance.now() < until;

export function runCountdown(ms: number): void {
  const secs = Math.round(ms / 1000);
  if (secs <= 0) return;
  document.querySelector('.countdown')?.remove();
  const num = el('div', { class: 'countdown__num' });
  const box = el('div', { class: 'countdown', role: 'status', 'aria-live': 'assertive' },
    el('div', { class: 'countdown__label', text: 'Get ready' }), num);
  document.body.append(box);
  const start = performance.now();
  until = start + ms;
  const { countdownSound: style, countdownVoice: voice } = prefs();
  audio.unlock();

  const show = (n: number): void => {
    num.textContent = n > 0 ? String(n) : 'GO!';
    num.classList.remove('countdown__num--pop');
    void num.offsetWidth;                         // restart the pop
    num.classList.add('countdown__num--pop');
    countdownStep(style, n, voice);
    if (n === 0) {
      audio.buzz(40);
      box.classList.add('countdown--go');
      window.setTimeout(() => box.remove(), 650);
    }
  };
  for (let i = 0; i <= secs; i++) {
    window.setTimeout(() => show(secs - i), Math.max(0, start + i * 1000 - performance.now()));
  }
}
